import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
const useOnClick = (ref, onClick) => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== onClick || $[1] !== ref) {
    t0 = () => {
      const node = ref.current;
      if (node && onClick) {
        node.addEventListener("click", onClick);
        return () => {
          node.removeEventListener("click", onClick);
        };
      }
      return _temp;
    };
    t1 = [onClick, ref];
    $[0] = onClick;
    $[1] = ref;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};
export default useOnClick;
function _temp() {}